export default {"src":"/_next/static/media/DXF.20976ae1.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};